import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useState
} from 'react';

const Context = createContext<{
  anchor: string | null;
  setAnchor: Dispatch<SetStateAction<string | null>>;
} | null>(null);

export function AnchorProvider({ children }: PropsWithChildren) {
  const [anchor, setAnchor] = useState<string | null>(null);
  return (
    <Context.Provider value={{ anchor, setAnchor }}>
      {children}
    </Context.Provider>
  );
}

export function useAnchorContext() {
  const value = useContext(Context);

  if (value === null) {
    throw new Error(
      'useAnchorContext() must be used within <AnchorProvider />'
    );
  }

  return value;
}
